export const include = (...relationships) => ({
  include: relationships.join(",")
});

export const nested = (...relationships) => relationships.join(".");

export const ADDRESSES = "addresses";
export const ADMINS = "admins";
export const AGENCY = "agency";
export const APPLICATIONS = "applications";
export const APPROVER = "approver";
export const ASSESSMENTS = "assessments";
export const AUTHOR = "author";
export const BOOKING = "booking";
export const BOOKING_APPROVERS = "booking-approvers,booking-approvers.user";
export const CAUSER = "causer";
export const CLIENT = "client";
export const COMMENTS = "comments";
export const COMPLIANCE_CHECKS = "compliance-checks";
export const CREATED_BY = "created-by";
export const ENTRIES = "entries";
export const EVENTS = "events";
export const EXPENSES = "expenses";
export const FILE = "file";
export const INTERMEDIARY_ORGANISATION = "intermediary-organisation";
export const LOCATION = "location";
export const MANAGER = "manager";
export const ORGANISATION = "organisation";
export const ORGANISATIONS = "organisations";
export const PAY_RATE_ITEMS = "pay-rate-items";
export const PARENT = "parent";
export const PAY_RATES = "pay-rates";
export const PUBLISHING_SCHEDULE = "publishing-schedules";
export const PUBLISHING_CHANNELS = "publishing-channels";
export const REFERENCES = "references";
export const SETTINGS = "settings";
export const TEMPLATE_PAY_RATES = "template-pay-rates";
export const TEMPLATE_PAY_RATES_ITEMS = `${TEMPLATE_PAY_RATES}.template-pay-rate-items`;
export const USER = "user";
export const ROLES = "roles";
export const VERIFIER = "verifier";
export const WORKER = "worker";
export const TIERS = "tiers";
export const ROOT_CLIENT = "root-client";
export const TEMPLATE_COSTS = "template-costs";
export const RECEIVER = "receiver";
export const INTERVIEWER = "interviewer";
export const AVAILABLE_INTERVIEW_SLOT = "available-interview-slot";
export const PARTICIPANTS = "participants";
export const INTERVIEW_SLOTS = "interview-slots";
export const INTERVIEW_SLOTS_UNFILLED = "interview-slots-unfilled";
export const FEEDBACKS = "feedbacks";
export const SCORES = "scores";
export const CRITERIA = "criteria";
export const FEEDBACK_CRITERIA = "feedback-criterias";
export const SENDER = "sender";
export const MESSAGES = "messages";
export const RECIPIENT = "recipient";
export const LAST_MESSAGE = "last-message";
export const BASIC_BOOKING = "basic-booking";
export const OPTIONS = "options";
export const DATA = "data";
export const CATEGORY = "category";
export const EVALUATION_STATUSES = "evaluation-statuses";
export const OFFER_GROUPS = "offer-groups";
export const OFFER_GROUP_DOCUMENTS = "documents";
export const APPLICATION = "application";
export const FUNCTION = "function";
export const EXPERIENCE = "experience";
export const CONVERSATION = "conversations";
export const REFEREE = "referee";
export const OFFERS = "offers";
export const CONVERSATIONS = "conversations";
export const DOCUMENT = "document";
export const USERS = "users";
export const CHARTS = "CHARTS";
export const CONTRACT_TYPES_GROUPINGS = "contract-types-groupings";
export const WORKING_HOURS_GROUPINGS = "working-hours-groupings";
export const OPTION = "option";
export const QUESTION = "question";
export const ANSWER = "answer";
export const APPROVAL_CHAIN_TEMPLATE_LEVELS = "approval-chain-template-levels";
export const PAGES = "pages";
export const APPROVERS = "approvers";
